import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    needToShowSets: true,
    hasDelayedEvents: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      'RED_CARD',
      'SECOND_YELLOW_CARD',
      'PLAYER_ON_PITCH'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away,
          customClass: ingameData => {
            const { playersCount: { home, away } } = ingameData

            if (Number(home) !== 6 || Number(away) !== 6) return 'football-players-count-changed'

            return ''
          }
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'football-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 6,
      away: 6
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    isReversedField: false,
    getOvertimePeriodName: 'ET',
    shootoutPeriodName: 'P',
    shootoutStatisticTitle: 'trader.penalty.shootout.score'
  }
}
